export const FeatureFlags = {
  EARNINGS_BENCHMARKS: 'earnings-benchmarks',
  AGREEMENTS_SERVER_SIDE_ENABLED: 'agreements-server-side-enabled',
  TUM_REDIRECT_ENABLED: 'tum-redirect-enabled',
  MULTIPLE_PAYMENT_TYPES: 'multiple-payment-types',
  PAYMENT_TYPES_ENABLED: 'payment-types-enabled',
  AGREEMENT_LINK_MULTIPLE_BUDGETS_ENABLED: 'agreement-link-multiple-budgets-enabled',
  AGREEMENT_CSV_UPLOAD_ENABLED: 'agreement-csv-upload-enabled',
  AGENTS_ENABLED: 'agents-enabled',
  AGENT_DIRECTORY_ENABLED: 'agent-directory-enabled',
  CONTRACT_REDLINING_ENABLED: 'contract-redlining',
  CONTRACT_VERSION_HISTORY_ENABLED: 'contract-version-history',
  PAYMENT_CHANGE_ACTIVITY_DRAWER_ENABLED: 'payment-change-activity-drawer-enabled',
  AGENTS_TYPE_ENABLED: 'agents-type-enabled',
  AGENT_CSV_UPLOAD_ENABLED: 'agent-csv-upload-enabled',
  GRANULAR_PERMISSIONS: 'granular-permissions-enabled',
  PVM_DASHBOARD_ENABLED: 'pvm-dashboard-enabled',
} as const;

export type FeatureFlag = keyof typeof FeatureFlags;
